import React, { createContext, useState, useEffect } from 'react';

const BookmarksContext = createContext();

export const BookmarksProvider = ({ children }) => {
  const [bookmarks, setBookmarks] = useState([]);


  useEffect(() => {
    const savedFiltersString = localStorage.getItem('savedFilters');
    const savedFilters = savedFiltersString ? JSON.parse(savedFiltersString) : [];
    setBookmarks(savedFilters);
  }, []);


  const addBookmark = (bookmark) => {
    const updatedBookmarks = [...bookmarks, bookmark];
    localStorage.setItem('savedFilters', JSON.stringify(updatedBookmarks));
    setBookmarks(updatedBookmarks);
  };


  const removeBookmark = (bookmark) => {
    const updatedBookmarks = bookmarks.filter(
      (item) => item.f14 !== bookmark.f14
    );
    localStorage.setItem('savedFilters', JSON.stringify(updatedBookmarks));
    setBookmarks(updatedBookmarks);
  };


  const isBookmarked = (bookmark) => {
    if (!bookmark || !bookmark?.f14) {
      return false;
    }

    return bookmarks?.some((item) => item?.f14 === bookmark.f14);
  };

  const updateBookmark = async(updatedBookmark) => {
    const updatedBookmarks = bookmarks.map(item => 
      item.f14 === updatedBookmark.f14 ? updatedBookmark : item
    );
    localStorage.setItem('savedFilters', JSON.stringify(updatedBookmarks));
    setBookmarks(updatedBookmarks);
    return updatedBookmark
  };

  const getBookmark = (bookmark) => {
    const updatedBookmarks = bookmarks.filter(
      (item) => item.f14 !== bookmark.f14
    );
    
    return JSON.parse(updatedBookmarks)
  };

  return (
    <BookmarksContext.Provider value={{ bookmarks, addBookmark, removeBookmark, isBookmarked, updateBookmark,getBookmark }}>
      {children}
    </BookmarksContext.Provider>
  );
};

export default BookmarksContext;